/**
 * Модель ответа привязки полей к программе
 *
 * @format
 */

export class ProjectAssign {
  newProjectId!: number;
  programLinkId!: number;
  partnerProgram!: string;
}
